export default {

    props: ["contactable", "contactableId"],

    data () {
        return {
            selectedRole: "",
            componentId: this._uid,
            showContactForm: false,
        };
    },

    computed: {},

    methods: {
        showContactCreateForm () {
            $("#modal-contact-create-form").modal("show");
        },

        hideContactCreateForm () {
            $("#modal-contact-create-form").modal("hide");
        },

        hideContactLinkForm () {
            $("#modal-contact-link-form").modal("hide");
        },

        toggleContactForm () {
            this.showContactForm = !this.showContactForm;
        },

        setRole (role) {
            this.selectedRole = role;
        },
    }
};
